// The invitation step's single selection, kept in `data.invitedProfiles` across tabs and steps:
// [{ type: "jobbiz" | "privatePool", id, name, detail }].

export const INVITED_PROFILE_TYPE = {
    JOBBIZ: "jobbiz",
    PRIVATE_POOL: "privatePool",
};

const asList = (profiles) => (Array.isArray(profiles) ? profiles : []);

const isSameProfile = (a, b) => a.type === b.type && String(a.id) === String(b.id);

export const isProfileInvited = (profiles, type, id) =>
    asList(profiles).some((profile) => isSameProfile(profile, { type, id }));

export const addInvitedProfile = (profiles, profile) =>
    asList(profiles).some((item) => isSameProfile(item, profile))
        ? asList(profiles)
        : [...asList(profiles), profile];

export const removeInvitedProfile = (profiles, profile) =>
    asList(profiles).filter((item) => !isSameProfile(item, profile));

export const toggleInvitedProfile = (profiles, profile) =>
    asList(profiles).some((item) => isSameProfile(item, profile))
        ? removeInvitedProfile(profiles, profile)
        : addInvitedProfile(profiles, profile);

/** Without `type`, every profile. */
export const countInvitedProfiles = (profiles, type) =>
    asList(profiles).filter((profile) => !type || profile.type === type).length;

/** POST mission/add format: { type: "jobbiz", tempWorkerId } | { type: "privatePool", memberId }. */
export const toInvitedProfilesPayload = (profiles) =>
    asList(profiles)
        .map((profile) => {
            if (profile.type === INVITED_PROFILE_TYPE.JOBBIZ) {
                return { type: INVITED_PROFILE_TYPE.JOBBIZ, tempWorkerId: profile.id };
            }
            if (profile.type === INVITED_PROFILE_TYPE.PRIVATE_POOL) {
                return { type: INVITED_PROFILE_TYPE.PRIVATE_POOL, memberId: profile.id };
            }
            return null;
        })
        .filter(Boolean);

// Absent means on: the switch defaults to "Jobbiz completes if needed".
export const isJobbizBackfillOn = (data) => data?.jobbizBackfill !== false;

/** With Jobbiz kept out, the mission needs at least one invited profile. */
export const isInvitationStepValid = (data) =>
    isJobbizBackfillOn(data) || countInvitedProfiles(data?.invitedProfiles) > 0;
